// extracted by mini-css-extract-plugin
export var content = "_mi-1";
export var divider = "_mi-0";